import { render, staticRenderFns } from "./modal-order-package.vue?vue&type=template&id=56b6071a&scoped=true&"
import script from "./modal-order-package.vue?vue&type=script&lang=js&"
export * from "./modal-order-package.vue?vue&type=script&lang=js&"
import style0 from "./modal-order-package.vue?vue&type=style&index=0&id=56b6071a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56b6071a",
  null
  
)

export default component.exports